import {Component, EventEmitter, inject, Input, OnInit, Output,ChangeDetectorRef} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Partner, TableColumn} from '@app/shared';
import {NZ_DRAWER_DATA, NzDrawerRef} from 'ng-zorro-antd/drawer';
import {MaestrosUtilsService} from '../../services/maestros-utils.service';
import {NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs} from 'ng-zorro-antd/upload';
import { Subscription} from 'rxjs';
import {ScreenService, getBase64, getPartnerOptions} from '@app/core';

@Component({
  selector: 'app-maestros-form-drawer',
  standalone: false,

  templateUrl: './maestros-form-drawer.component.html',
  styleUrl: './maestros-form-drawer.component.less',
})
export class MaestrosFormDrawerComponent implements OnInit {
  nzData: {
    columnsData: TableColumn[];
    editingElement: any;
    maestroName: string;
  } = inject(NZ_DRAWER_DATA);

  missingData: string | undefined;

  dynamicForm!: FormGroup;

  loading: boolean = false;
  isMobile$;
  avatarUrl: any;

  @Output() createEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private drawerRef: NzDrawerRef<string>,
    private ms: MaestrosUtilsService,
    private screenService: ScreenService,
    private cdRef: ChangeDetectorRef
  ) {
    ms.loading.subscribe((value: boolean) => (this.loading = value));
    this.isMobile$ = screenService.isMobile$;
  }

  ngOnInit(): void {
    this.setForm();
  }

  // Metodo para crear el formulario dinamico
  setForm(): void {
    const formGroupConfig: { [key: string]: any } = {};

    // Se genera la configuracion general del formulario por cada propiedad que se tenga
    this.nzData.columnsData.forEach((column) => {
      if (
        this.nzData.editingElement ||
        (!this.nzData.editingElement && column.pathData!.name !== 'id')
      ) {
        if (column.pathData!.type === 'select' && !column.optionList?.length) {
          this.missingData = column.pathData!.name;
          return;
        }

        if (column.pathData!.type === 'multi-select') {
          // [initialValue] = [[]] so validators push at index 1: [[], [validatorFn]]
          formGroupConfig[column.pathData!.name] = [[]]
        }
        else {
          formGroupConfig[column.pathData!.name] = [column.defaultValue ? column.defaultValue : ''];

        formGroupConfig[column.pathData!.name] = [
          column.defaultValue ? column.defaultValue : '',
        ];

          formGroupConfig[column.pathData!.name] = [column.defaultValue ? column.defaultValue : ''];
        }
        if (column.validators && column.validators.length > 0) {
          formGroupConfig[column.pathData!.name].push(
            column.validators.map((validator) => validator.function)
          );
        }
      }
    });

    // Se crea el formulario con la configuracion anterior
    this.dynamicForm = this.fb.group(formGroupConfig);

    // Si se esta editando se llena el form con los datos actuales
    if (this.nzData.editingElement) {
      this.dynamicForm.patchValue(this.nzData.editingElement);
      if (this.nzData.editingElement.image) {
        this.avatarUrl = this.nzData.editingElement.image;
      }
    }
  }

  close(): void {
    this.drawerRef.close();
  }

  onSubmit(): void {
    if (this.nzData.editingElement) {
      this.updateEvent.emit(this.dynamicForm.value);
    } else {
      this.createEvent.emit(this.dynamicForm.value);
    }
  }

  getValidatorError(column: TableColumn) {
    const control = this.dynamicForm.get(column.pathData!.name);
    if (
      control &&
      control?.errors &&
      column.validators &&
      column.validators.length > 0
    ) {
      return Object.keys(control.errors)
        .map(
          (key) =>
            column.validators!.find((validator) => validator.error === key)!
              .message
        )
        .join(', ');
    }
    return '';
  }

  // Metodo para prevenir el error en el navegador de una peticion erronea del nz-upload
  customUpload = (item: NzUploadXHRArgs): Subscription => {
    // Simula un retardo (opcional)
    setTimeout(() => {
      // Llama al callback de éxito para que nz-upload marque el archivo como subido
      item.onSuccess!({}, item.file, null);
    }, 0);
    // Retorna una suscripción vacía, ya que no se está haciendo una petición real
    return new Subscription();
  };

  handleUploadChange(info: NzUploadChangeParam, column: TableColumn): void {
    const file: NzUploadFile | undefined =
      info.fileList[info.fileList.length - 1];
    if (file) {
      this.loading = true;
      const control = this.dynamicForm.get(column.pathData!.name);
      if (control) {
        control.setValue(file.originFileObj as File);
        getBase64(info.file!.originFileObj!, (img: string) => {
          this.loading = false;
          this.avatarUrl = img;
          this.cdRef.detectChanges();
        });
      }
    }
  }

  compareFn = (o1: any, o2: any) => (o1 && o2 ? o1.id === o2.id : o1 === o2);

  protected readonly getPartnerOptions = getPartnerOptions;
}
